
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";
import { foundersData, jointFoundersBio } from "@/data/founders";
import { ArrowRight } from "lucide-react";

export const AboutSection: React.FC = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-16 md:py-24 bg-palsustain-beige/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-palsustain-green mb-6">
              {t("home.about.title")}
            </h2>
            
            <p className="text-lg text-palsustain-charcoal/80 mb-4">
              {t("home.about.description")}
            </p>
            
            <p className="text-lg text-palsustain-charcoal/80 mb-8">
              {t("home.about.mission")}
            </p>
            
            <Link 
              to="/journey" 
              className="inline-flex items-center px-6 py-3 bg-palsustain-green text-white font-medium rounded-md hover:bg-palsustain-green/90 transition-all duration-300"
            >
              {t("nav.journey")}
              <ArrowRight className={`ml-2 h-4 w-4 ${language === "ar" ? "transform rotate-180" : ""}`} />
            </Link>
          </div>
          
          <div className="order-1 lg:order-2">
            <h3 className="text-2xl font-bold text-palsustain-green mb-4">
              {t("home.founders.title")}
            </h3>

            <p className="text-palsustain-charcoal/80 mb-6">
              {language === "en" ? jointFoundersBio.en : jointFoundersBio.ar}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {foundersData.map((founder) => (
                <div key={founder.id} className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg">
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={founder.image} 
                      alt={language === "en" ? founder.name.en : founder.name.ar}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                  <div className="p-4">
                    <h4 className="text-xl font-bold mb-1">
                      {language === "en" ? founder.name.en : founder.name.ar}
                    </h4>
                    <p className="text-sm text-palsustain-charcoal/70">
                      {language === "en" ? founder.role.en : founder.role.ar}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
